<div class="chgPwd">
  <app-info-bar-v01-h00-c00-change-password></app-info-bar-v01-h00-c00-change-password>
  <app-change-password-content></app-change-password-content>
</div>
